import { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminUsersQueryKey } from "../admin-user.keys";

export const useAdminFetchAdminUsers = (shouldSkipQuery?: boolean) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: adminUsersQueryKey(),
		queryFn: async () => {
			if (shouldSkipQuery) {
				return [] as Dtos.Admin.AdminUser.Get.Response[];
			}
			return await get<Dtos.Admin.AdminUser.Get.Response[]>(`/v2/admin/admin-users`);
		},
	});

	return { adminUsers: data, adminUsersError: error, adminUsersLoading: isLoading };
};
